import dayjs from "dayjs";
import timezone from "dayjs/plugin/timezone";
import utc from "dayjs/plugin/utc";

dayjs.extend(utc);
dayjs.extend(timezone);

const pad = (value: number, length = 2) => String(value).padStart(length, "0");

export function toDateInTimeZone(date: Date | undefined, timeZone: string): Date | undefined {
  if (!date) return undefined;

  return dayjs.tz(toWallClockValue(date), timeZone).toDate();
}

export function toIsoStringWithOffset(
  date: Date | undefined,
  timeZone: string,
): string | undefined {
  if (!date) return undefined;

  return dayjs.tz(toWallClockValue(date), timeZone).format("YYYY-MM-DDTHH:mm:ss.SSSZ");
}

function toWallClockValue(date: Date): string {
  return [
    date.getFullYear(),
    "-",
    pad(date.getMonth() + 1),
    "-",
    pad(date.getDate()),
    "T",
    pad(date.getHours()),
    ":",
    pad(date.getMinutes()),
    ":",
    pad(date.getSeconds()),
    ".",
    pad(date.getMilliseconds(), 3),
  ].join("");
}
